"use client";

import React from "react";

export type VariablesContextValue = Record<string, unknown> | null;

export const VariablesContext = React.createContext<VariablesContextValue>(null);
